import styled from '@emotion/styled'

//TODO: Clean up, I believe I can make this less crazy CSS

export const TripleDotLoaderContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 -5%;
`

export const TripleDots = styled.div`
  position: relative;
  left: -9999px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: var(--white);
  color: var(--white);
  box-shadow: 9999px 0 0 -5px;
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 4px;
    height: 4px;
    border-radius: 5px;
    background-color: var(--white);
    color: var(--white);
  }

  &::before {
    box-shadow: 9984px 0 0 -5px;
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }

  &::after {
    box-shadow: 10014px 0 0 -5px;
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }

  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9984px 0 0 -5px;
    }

    30% {
      box-shadow: 9984px 0 0 2px;
    }

    60%,
    100% {
      box-shadow: 9984px 0 0 -5px;
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px;
    }

    30% {
      box-shadow: 9999px 0 0 2px;
    }

    60%,
    100% {
      box-shadow: 9999px 0 0 -5px;
    }
  }

  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10014px 0 0 -5px;
    }

    30% {
      box-shadow: 10014px 0 0 2px;
    }

    60%,
    100% {
      box-shadow: 10014px 0 0 -5px;
    }
  }
`
